import {createApp} from "vue";
////asdadadadasd
// Application imports
import {NPPdfModal} from '../netpify/components';
import locale from "netpify/mixins/locale";


const app=createApp({
    el: '#vue-app',
     components: {
         'np-pdf-modal': NPPdfModal
     },
    methods: {
        setModalData: function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $('#elavon-gdpr-pdf').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
    }
});
app.mixin(locale);
app.use('np-pdf-modal', NPPdfModal);
app.mount('#vue-app');